import api from './index'
import request from '@/utils/request'

// 商户系统 订单计费明细查询
/**
 * @description 获取商户编号下拉列表
 */
export function getAllSubMerchantNames (data) {
  return request({
    url: `${api.getAllSubMerchantNames}`,
    method: 'post',
    data
  })
}
/**
 * @description 订单计费明细查询
 */
export function queryOrderBillingDetailsList (data) {
  return request({
    url: `${api.queryOrderBillingDetailsList}`,
    method: 'post',
    data
  })
}
/**
 * @description 订单计费明细查询导出
 */
export function exportOrderBillingDetails (data) {
  return request({
    url: `${api.exportOrderBillingDetails}`,
    method: 'post',
    data
  })
}
// 商户系统 交易订单差错处理
/**
 * @description 交易订单差错处理
 */
export function listMerchantErrorTicket (data) {
  return request({
    url: `${api.listMerchantErrorTicket}`,
    method: 'post',
    data
  })
}
/**
 * @description 交易订单差错处理导出
 */
export function exportMerchantErrorTicket (data) {
  return request({
    url: `${api.exportMerchantErrorTicket}`,
    method: 'post',
    data
  })
}
// 代理商系统 订单计费明细查询
/**
 * @description 代理商查询下属商户列表
 */
export function listAgentMerchant (data) {
  return request({
    url: `${api.listAgentMerchant}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户订单计费明细
 */
export function listMerchantStatement (data) {
  return request({
    url: `${api.listMerchantStatement}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户订单计费明细导出
 */
export function exportMerchantStatement (data) {
  return request({
    url: `${api.exportMerchantStatement}`,
    method: 'post',
    data
  })
}
// 代理商系统 交易订单差错处理
/**
 * @description 下级代理商信息查看
 */
export function subAgentInfo (data) {
  return request({
    url: `${api.subAgentInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 打款查询导出
 */
export function exportMerchantPaybill (data) {
  return request({
    url: `${api.exportMerchantPaybill}`,
    method: 'post',
    data
  })
}
/**
 * @description 查看打款详情
 */
export function lookUpDetailInfo (data) {
  return request({
    url: `${api.lookUpDetailInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 查看打款详情
 */
export function listPaybill (data) {
  return request({
    url: `${api.listPaybill}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润汇总
 */
export function countAgentProfit (data) {
  return request({
    url: `${api.countAgentProfit}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润汇总导出
 */
export function exportCountAgentProfit (data) {
  return request({
    url: `${api.exportCountAgentProfit}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润提取记录
 */
export function queryAgentWithdrawOrder (data) {
  return request({
    url: `${api.queryAgentWithdrawOrder}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润明细
 */
export function listProfitDetail (data) {
  return request({
    url: `${api.listProfitDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润明细导出
 */
export function exportProfitDetail (data) {
  return request({
    url: `${api.exportProfitDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取图片显示路径
 */
export function singleTranferPic (data) {
  return request({
    url: `${api.singleTranferPic}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取图片显示路径
 */
export function profitStatistics (data) {
  return request({
    url: `${api.profitStatistics}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润提取
 */
export function profitPickUp (data) {
  return request({
    url: `${api.profitPickUp}`,
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data
  })
}
/**
 * @description 蓝海分润提取
 */
export function blueSeaPickUp (data) {
  return request({
    url: `${api.blueSeaPickUp}`,
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data
  })
}
/**
 * @description 绿洲分润提取
 */
export function oasisPickUp (data) {
  return request({
    url: `${api.oasisPickUp}`,
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data
  })
}
/**
 * @description 分润-发票图片上传
 */
export function uploadInvoiceImage (data) {
  return request({
    url: `${api.uploadInvoiceImage}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润-发票列表
 */
export function queryAgentInvoiceList (data) {
  return request({
    url: `${api.queryAgentInvoiceList}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润-发票录入
 */
export function inputAgentInvoice (data) {
  return request({
    url: `${api.inputAgentInvoice}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润-编辑发票信息
 */
export function updateInvoice (data) {
  return request({
    url: `${api.updateInvoice}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润-批量导入发票
 */
export function batchInputInvoice (data) {
  return request({
    url: `${api.batchInputInvoice}`,
    method: 'post',
    data
  })
}
/**
 * @description 分润-删除发票
 */
export function deleteInvoice (data) {
  return request({
    url: `${api.deleteInvoice}`,
    method: 'post',
    data
  })
}
/**
 * @description 发票申请列表
 */
export function invoiceList (data) {
  return request({
    url: `${api.invoiceList}`,
    method: 'post',
    data
  })
}
/**
 * @description 发票申请
 */
export function applyInvoice (data) {
  return request({
    url: `${api.applyInvoice}`,
    method: 'post',
    data
  })
}
/**
 * @description 开票记录列表
 */
export function applyInvoiceRecordList (data) {
  return request({
    url: `${api.applyInvoiceRecordList}`,
    method: 'post',
    data
  })
}
/**
 * @description 撤销申请发票
 */
export function cancelApplyInvoice (data) {
  return request({
    url: `${api.cancelApplyInvoice}`,
    method: 'post',
    data
  })
}
/**
 * @description 发票记录导出
 */
export function invoiceExport (data) {
  return request({
    url: `${api.invoiceExport}`,
    method: 'post',
    data
  })
}
// 商户 打款
/**
 * @description 打款查询
 */
export function listPayOrder (data) {
  return request({
    url: `${api.listPayOrder}`,
    method: 'post',
    data
  })
}
/**
 * @description 打款单查询导出
 */
export function exportPayOrder (data) {
  return request({
    url: `${api.exportPayOrder}`,
    method: 'post',
    data
  })
}
/**
 * @description 账户查询
 */
export function listAccount (data) {
  return request({
    url: `${api.listAccount}`,
    method: 'post',
    data
  })
}
/**
 * @description 账户查询导出
 */
export function exportMerchantAccount (data) {
  return request({
    url: `${api.exportMerchantAccount}`,
    method: 'post',
    data
  })
}
/**
 * @description 账户流水查询
 */
export function listAccountFlow (data) {
  return request({
    url: `${api.listAccountFlow}`,
    method: 'post',
    data
  })
}
/**
 * @description 账户流水查询导出
 */
export function exportAccountFlow (data) {
  return request({
    url: `${api.exportAccountFlow}`,
    method: 'post',
    data
  })
}
/**
 * @description 智能进件查询修改结算卡审核状态
 */
export function checkSettleStatus (data) {
  return request({
    url: `${api.checkSettleStatus}`,
    method: 'post',
    data
  })
}
/**
 * @description 发票精确查询
 */
export function accurateQuery (data) {
  return request({
    url: `${api.accurateQuery}`,
    method: 'post',
    data
  })
}
/**
 * @description 发票模糊查询
 */
export function dimQuery (data) {
  return request({
    url: `${api.dimQuery}`,
    method: 'post',
    data
  })
}
/**
 * @description 奖励返佣分润提取
 */
export function commissionPickUp (data) {
  return request({
    url: `${api.commissionPickUp}`,
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data
  })
}

/**
 * @description 获取上次填入信息
 */
export function getLastApplyRecord (data) {
  return request({
    url: `${api.getLastApplyRecord}`,
    method: 'post',
    data
  })
}

/**
 * @description 自动开票配置列表
 */
export function listAutoInvoice (data) {
  return request({
    url: `${api.listAutoInvoice}`,
    method: 'post',
    data
  })
}

/**
 * @description 新增开票设置
 */
export function applyAutoInvoice (data) {
  return request({
    url: `${api.applyAutoInvoice}`,
    method: 'post',
    data
  })
}

/**
 * @description 修改开票设置
 */
export function updateAutoInvoice (data) {
  return request({
    url: `${api.updateAutoInvoice}`,
    method: 'post',
    data
  })
}

/**
 * @description 修改开票设置状态
 */
export function updateAutoInvoiceState (data) {
  return request({
    url: `${api.updateAutoInvoiceState}`,
    method: 'post',
    data
  })
}

/**
 * @description 机构发票列表
 */
export function listCustomerInvoice (data) {
  return request({
    url: `${api.listCustomerInvoice}`,
    method: 'post',
    data
  })
}

/**
 * @description 机构发票导出
 */
export function exportCustomerInvoice (data) {
  return request({
    url: `${api.exportCustomerInvoice}`,
    method: 'post',
    data
  })
}

/**
 * @description 机构分润明细
 */
export function listCustomerProfitDetail (data) {
  return request({
    url: `${api.listCustomerProfitDetail}`,
    method: 'post',
    data
  })
}

/**
 * @description 导出机构分润明细
 */
export function exportCustomerProfitDetail (data) {
  return request({
    url: `${api.exportCustomerProfitDetail}`,
    method: 'post',
    data
  })
}

/**
 * @description 机构分润汇总
 */
export function listCustomerProfitStatistics (data) {
  return request({
    url: `${api.listCustomerProfitStatistics}`,
    method: 'post',
    data
  })
}

/**
 * @description 导出机构分润统计列表
 */
export function exportCustomerProfitStatistics (data) {
  return request({
    url: `${api.exportCustomerProfitStatistics}`,
    method: 'post',
    data
  })
}

/**
 * @description 查看同主体多商户
 */
export function listAutoInvoiceMulti (params) {
  return request({
    url: `${api.listAutoInvoiceMulti}`,
    method: 'get',
    params
  })
}

/**
 * @description 查看同主体多商户
 */
export function rebateDetailList (data) {
  return request({
    url: `${api.rebateDetailList}`,
    method: 'post',
    data
  })
}
